import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import { TableRow } from '../Table';
import CompareModelsTableHeader from './CompareModelsTableHeader';
import type {
  CompareModelsModalVariant,
  CompareModelsTableHeaderVAlign,
} from './types';

export interface CompareModelsTableRowProps {
  readonly className?: string;
  readonly header?: MessageKey;
  readonly headerAlign?: CompareModelsTableHeaderVAlign;
  readonly headerClassName?: string;
  readonly headerLabelClassName?: string;
  readonly isLastRow?: boolean;
  readonly variant?: CompareModelsModalVariant;
}

const CompareModelsTableRow = ({
  children,
  className,
  header,
  headerAlign = 'top',
  headerClassName,
  headerLabelClassName,
  isLastRow = false,
  variant = { md: 'two_column', lg: 'three_column' },
}: PropsWithChildren<CompareModelsTableRowProps>) => {
  return (
    <TableRow
      className={cx(
        'flex flex-wrap gap-x-10 gap-y-4',
        {
          'max-lg:border-b max-lg:border-gray-300 max-lg:last:border-b-0':
            variant.md === 'two_column',
          'max-md:border-b max-md:border-gray-300 max-md:last:border-b-0':
            variant.md === 'three_column',
        },
        className,
      )}
    >
      <CompareModelsTableHeader
        isLastRow={isLastRow}
        label={header}
        verticalAlign={headerAlign}
        className={headerClassName}
        labelClassName={headerLabelClassName}
        variant={variant}
      />
      {children}
    </TableRow>
  );
};

export default CompareModelsTableRow;
